<template>
  <v-data-table
    :headers="headers"
    :items="customers"
    :footer-props="{
      'items-per-page-options': [10, 25, 50, 100]
    }"
    @click:row="rowClick"
    class="row-pointer"
    :loading="loading"
  >
    <template v-slot:item.name="{ item }">
      <team-chip :team="item"></team-chip>
    </template>
    <template v-slot:item.userRecords.value.completion="{ item }">
      <simple-engagement-text
        :engagement="item.userRecords.value"
      ></simple-engagement-text>
    </template>
    <template v-slot:item.score.value="{ item }">
      <v-row dense v-if="item.score && item.score.value">
        <v-col cols="auto">
          <v-img
            :src="$coreScores.getOverallImage(item.score.value)"
            height="25"
            width="25"
            contain
          ></v-img>
        </v-col>
        <v-col class="my-auto">
          {{ item.score.value | no_decimal }}
        </v-col>
      </v-row>
    </template>
    <template v-slot:item.score.percentChange="{ item }">
      <compare-text
        v-if="item.score"
        :old-value="item.score.compare"
        :new-value="item.score.value"
        inherit
        :timeframeId="1"
      ></compare-text>
    </template>
    <template v-slot:item.actions="{}">
      <v-btn icon>
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import CompareText from "@/components/reporting/CompareText";
import SimpleEngagementText from "@/components/reporting/SimpleEngagementText";
export default {
  name: "CustomerTable",
  components: { CompareText, SimpleEngagementText },
  props: {
    loading: { type: Boolean, default: false },
    showPlan: { type: Boolean, default: false },
    customers: { type: Array }
  },
  data: () => ({}),
  computed: {
    headers() {
      let items = [
        { text: "Name", value: "name" },
        { text: "Members", value: "userCount.value" }
      ];
      if (this.showPlan) {
        items.push({ text: "Plan", value: "planTypeName" });
      }
      items = items.concat([
        { text: "Participation", value: "userRecords.value.completion" },
        { text: "Overall Score", value: "score.value" },
        {
          text: "Trend",
          value: "score.percentChange"
        },
        { text: "", value: "actions" }
      ]);
      return items;
    },
    ...mapGetters({})
  },
  created() {},
  methods: {
    rowClick(item) {
      this.$router.push({ path: `/portal/customers/${item.id}` });
    }
  }
};
</script>
